import McpPanel from '../../components/McpPanel';

export default function Hermes() {
  return (
    <div data-testid="workspace-hermes" style={{ maxWidth: 1040, margin: '0 auto' }}>
      <McpPanel />
    </div>
  );
}
